export default __webpack_public_path__ + "static/octopus-3d62901349fd6eb4f9332165cfbcf371.webp";